module.exports = __webpack_public_path__ + "static/media/cover.41501600.png";